<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        
        <v-alert :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" @submit="login">

            <v-text-field outline v-model="username" :rules="usernameRules" label="Email *"  type="email" required ></v-text-field>

            <v-text-field outline v-model="pass" label="Existing password *" type="password" required ></v-text-field>

            <v-text-field outline v-model="newPassword" :rules="passRules" label="New Password *" type="password" required ></v-text-field>

            <v-layout row align-center mx-1>
              <router-link to="forgot-password" class="text-button">Forgotten password?</router-link>
              <v-spacer />
              <button type="submit" :disabled="!valid" class="button">Login</button>
            </v-layout>

          </v-form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'SetNewPasswordForm',
  data () {
    
    return {
      valid: true,
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Remember, your password will have been at least 8 characters, contained a special character and contained both an upper case and a lower case letter'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      username: '',
      pass: '',
      newPassword: '',
      error: null,
      success: null,
      loading: false
    }
  },
  mounted () {
    console.log('Login component loaded ')
    if(window.location.href.includes("code=true")){ //if the user is referred from a partner site
      localStorage.referrer = document.referrer
      this.success = {message: 'Your membership has been authenticated, please login below.'}
    }
        
  },
  methods: {
    login (e) {
      e.preventDefault()

        this.loading = true
        var email = this.username
        var password = this.pass
        var newPassword = this.newPassword
        

        this.$authenticateUser(email, password, newPassword).subscribe((data) => {
            console.log('login success')
            // mobile app event trigger

            var lastSub = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
            var idToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)
            var refreshToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.refreshToken`)
            var accessToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.accessToken`)

            var tokens = {
              'idToken' : idToken,
              'refreshToken' : refreshToken,
              'accessToken' : accessToken
            }

            if (typeof window.android !== 'undefined') { 
              window.android.onSignInSuccess(idToken)
              window.android.passTokens(JSON.stringify(tokens)) 
            }
            if (typeof window.webkit !== 'undefined') { 
              
              window.webkit.messageHandlers.iOS.postMessage(idToken)
              window.webkit.messageHandlers.iOSTokens.postMessage(JSON.stringify(tokens))

            }
            if(localStorage.referrer){ // if they were a referral sign in then clear this and redirect them.
              var redirect = localStorage.referrer
              console.log('redirecting to ' + redirect)
              localStorage.removeItem('referrer')
              window.location = redirect
            }else{
              this.$router.push("/profile")
            }
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            this.error = err;
            if(err.code === "UnknownError" || err.code === "newPasswordRequired"){
                this.$router.push("/login-set-password");
            }
        this.emailVerificationMessage = true;
        });

    }
  }
}
</script>

<style scoped>
</style>